import { Box, Table, TableContainer, Tbody, Text, Th, Thead, Tr, useDisclosure } from '@chakra-ui/react'
import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { GetPendingSRA } from '../Utils/ApiCalls'
import MorePendingSRA from './MorePendingSra';
import MoreSRA from './MoreSRA';
import PendingIQA from './PendingIQA';
import TableRow from './TableRow'

export default function SraApproval() {

    const [Data, setData] = useState([]);
    const [SraID, setSraID] = useState("");
    const [Id, setId] = useState("");
    const [HandleMoreSRA, setHandleMoreSRA] = useState(false);
    const { isOpen, onOpen, onClose } = useDisclosure();



    const AllSRA = async () => {
        let result = await GetPendingSRA()

        console.log("object pending sra", result);

        if (result.status == true) {
            setData(result.queryresult.sraproductdetails)

        }
    }

    const openApprove = (id)=>{
        onOpen()
        setId(id)
      }

    const openSra = (id) => {
        setHandleMoreSRA(true)

        let single = Data.filter((item) => {
            return item._id == id
        })
//single Data 
        setSraID(single)
    }


    useEffect(() => {

        AllSRA()

    }, [isOpen]);


    return (
        <Box display={"block"} alignItems="flex-start" w={"100%"} height="70vh" minH={"70vh"} overflow="auto" _hover={{ overflow: "auto" }} bg="blue.blue200" mt="32px" rounded={"8px"}>

            <Text p="10px"  textTransform="Capitalize" color="#fff" display={"flex"} justifyContent="flex-end">Total Pending Approval - {Data.length}</Text>

            <TableContainer w={"100%"} mt="32px" overflowX="auto" color="#fff"

            >
            <Table variant='simple' size='sm' overflowX="auto" >
                    <Thead>
                        <Tr>
                            <Th color="#fff">S/N</Th>
                            <Th color="#fff">Suppliers </Th>
                            <Th color="#fff">Raised by</Th>
                            <Th color="#fff">Date received</Th>
                            <Th color="#fff">Invoice Number</Th>
                            <Th color="#fff">Approval</Th>
                            <Th color="#fff">View More</Th>

                        </Tr>
                    </Thead>
                    <Tbody>

                        {

                            Data?.map((item, i) => (
                                <TableRow
                                    type="sraApproval"
                                    sn={i + 1}
                                    raised={item.sra?.raised}
                                    supplierName={item.sra?.suppliersname}
                                    dateReceived={moment(item.datereceived).format('DD/MM/YYYY')}
                                    invoiceNo={item.sra?.invoicenumber}
                                    onClick={() => openSra(item._id)}
                                    Approve={() => openApprove(item._id)}



                                />
                            ))
                        }


                    </Tbody>

                </Table>
            </TableContainer>
            <MorePendingSRA isOpen={HandleMoreSRA} onClose={()=>setHandleMoreSRA(false)} singleData={SraID}/>
            <PendingIQA isOpen={isOpen} onClose={onClose} id={Id} state="ApproveSra"/>

        </Box>
    )
}
